"use client";

import { useViewedScreen } from "@packages/analytics";
import { useRestrictedContentCheck } from "@packages/kids";
import type { TrustedCollection } from "@packages/sdk";
import { useRequestCollection } from "@packages/sdk";

import { LoadingPage } from "../../../../../components";
import CollectionContent from "./CollectionContent";
import CollectionFiltered from "./CollectionFiltered";

type CollectionClientProps = {
  id: number;
  initialData: TrustedCollection;
  filter?: string;
};

const CollectionClient = ({
  id,
  filter,
  initialData,
}: CollectionClientProps) => {
  const { query: queryCollection } = useRequestCollection({
    id,
    initialData,
    retryOnMount: false,
    retry: 0,
  });

  const isRestricted = useRestrictedContentCheck({ query: queryCollection });

  useViewedScreen({
    screen: "collection_detail",
    properties: {
      collection: id,
    },
  });

  if (isRestricted || queryCollection.isLoading) return <LoadingPage />;

  return filter ? (
    <CollectionFiltered
      filter={filter}
      collection={queryCollection.data ?? initialData}
      isLoading={queryCollection.isLoading}
    />
  ) : (
    <CollectionContent
      collection={queryCollection.data ?? initialData}
      isLoading={queryCollection.isLoading}
    />
  );
};

export default CollectionClient;
